import request from '@/utils/request'
import config from '@/config'

export default {
  // 防治区
  getPreventionAreaInfo (params) {
    return request.get(config.ApiYJ + '/Base/PreventionAreaInfo', { params })
  },
  savePreventionAreaInfo (preventGroup) {
    return request.post(config.ApiYJ + '/Base/PreventionAreaInfo', preventGroup)
  },
  deletePreventionAreaInfo (id) {
    return request.post(config.ApiYJ + '/Base/del_PreventionAreaInfo', { id: id })
  },
  // 历史山洪灾害调查情况操作
  getFloodInfo (params) {
    return request.get(config.ApiYJ + '/FloodInfo/FloodInfo', { params })
  },
  saveFloodInfo (preventGroup) {
    return request.post(config.ApiYJ + '/FloodInfo/FloodInfo', preventGroup)
  },
  deleteFloodInfo (id) {
    return request.post(config.ApiYJ + '/FloodInfo/del_FloodInfo', { id: id })
  },
  // 水库
  getReservoir (params) {
    return request.get(config.ApiYJ + '/Project/Reservoir?jsconfig=dh:iso8601dt', { params })
  },
  saveReservoir (preventGroup) {
    return request.post(config.ApiYJ + '/Project/Reservoir', preventGroup)
  },
  deleteReservoir (id) {
    return request.post(config.ApiYJ + '/Project/del_Reservoir', { id: id })
  },
  // 水闸
  getSluice (params) {
    return request.get(config.ApiYJ + '/Project/Sluice', { params })
  },
  saveSluice (preventGroup) {
    return request.post(config.ApiYJ + '/Project/Sluice', preventGroup)
  },
  deleteSluice (id) {
    return request.post(config.ApiYJ + '/Project/del_Sluice', { id: id })
  },
  // 堤防
  getDike (params) {
    return request.get(config.ApiYJ + '/Project/Dike', { params })
  },
  saveDike (preventGroup) {
    return request.post(config.ApiYJ + '/Project/Dike', preventGroup)
  },
  deleteDike (id) {
    return request.post(config.ApiYJ + '/Project/del_Dike', { id: id })
  },
  // 塘堰坝
  getDam (params) {
    return request.get(config.ApiYJ + '/Project/Dam', { params })
  },
  saveDam (preventGroup) {
    return request.post(config.ApiYJ + '/Project/Dam', preventGroup)
  },
  deleteDam (id) {
    return request.post(config.ApiYJ + '/Project/del_Dam', { id: id })
  },
  // 简易水位/雨量站
  getSimpleRainAndWater (params) {
    return request.get(config.ApiYJ + '/Station/SimpleRainAndWater', { params })
  },
  saveSimpleRainAndWater (stationGroup) {
    return request.post(config.ApiYJ + '/Station/SimpleRainAndWater', stationGroup)
  },
  deleteSimpleRainAndWater (id) {
    return request.post(config.ApiYJ + '/Station/del_SimpleRainAndWater', { id: id })
  },
  // 自动遥测站
  getStationInfo (params) {
    return request.get(config.ApiYJ + '/Station/StationInfo', { params })
  },
  saveStationInfo (stationGroup) {
    return request.post(config.ApiYJ + '/Station/StationInfo', stationGroup)
  },
  deleteStationInfo (id) {
    return request.post(config.ApiYJ + '/Station/del_StationInfo', { id: id })
  },
  getstationBaseList (params) {
    return request.get(config.ApiYJ + '/HydrologyCenter/station_base_list', { params })
  },
  // 导出
  exportStationInfo (params) {
    return request.post(config.ApiYJ + '/Export/BaseStationExport', params)
  },
  exportWarnIndex (params) {
    return request.post(config.ApiYJ + '/Export/exportWarnIndex', params)
  },
  // 获取全部测站
  getSiteFindAllList (params) {
    return request.get(config.ApiYJ + '/site/findAll', { params })
  },
  // 获取全部测站
  getSiteFindMainList (params) {
    return request.get(config.ApiYJ + '/site/findMain', { params })
  },
  // 预案信息
  getPlan (params) {
    return request.get(config.ApiYJ + '/Base/Plan', { params })
  },
  savePlan (stationGroup) {
    return request.post(config.ApiYJ + '/Base/Plan', stationGroup)
  },
  deletePlan (id) {
    return request.post(config.ApiYJ + '/Base/del_Plan', { id: id })
  },
  // 预警指标信息
  getWarnIndex (params) {
    return request.get(config.ApiYJ + '/Base/WarnIndex', { params })
  },
  saveWarnIndex (stationGroup) {
    return request.post(config.ApiYJ + '/Base/WarnIndex', stationGroup)
  },
  deleteWarnIndex (id) {
    return request.post(config.ApiYJ + '/Base/del_WarnIndex', { id: id })
  },
  // 行政区划三级联动接口
  getMutiRanksAdcd (params) {
    return request.get(config.ApiYJ + '/Base/GetMutiRanksAdcd', { params })
  },
  // 行政区划
  getAdcd (params) {
    return request.get(config.ApiYJ + '/Base/Adcd', { params })
  },
  // 行政区划基本信息
  getAdcdBaseInfo (params) {
    return request.get(config.ApiYJ + '/Base/GetAdcdBaseInfo', { params })
  },
  // 行政区划新增修改
  upAdcd (params) {
    return request.post(config.ApiYJ + '/Base/Adcd', params)
  },
  // 行政区划新增删除
  delAdcd (id) {
    return request.post(config.ApiYJ + '/Base/del_Adcd', { id: id })
  },
  // 库(湖)容曲线
  getStorageCurveStation (params) {
    return request.get(config.ApiYJ + '/synchronization/get_storage_curve_station', { params })
  },
  getStorageCurve (params) {
    return request.get(config.ApiYJ + '/synchronization/get_storage_curve', { params })
  },
  saveStorageCurve (params) {
    return request.post(config.ApiYJ + '/synchronization/save_storage_curve', params)
  }
}
